<template>
    <div class="call-to-action-section">
        <h2 class="call-to-action-section__title">{{ title }}</h2>
        <BaseButton class="call-to-action-section__submit-button" 
            :text="submitButtonText" 
            theme="primary-invert"
            size="big"
            @click.native="submitButtonCallback"
            />
    </div>
</template>

<script>
import BaseButton from '@/components/ui/BaseButton';
export default {
    name: 'CallToAction',
    components: {
        BaseButton
    },
    props: {
        title: {
            type: String,
            required: true
        },
        submitButtonText: {
            type: String,
            required: true
        },
        submitButtonCallback: {
            type: Function,
            required: true
        }
    }
}
</script>

<style lang="scss" scoped>
.call-to-action-section {
    @include flex-space-between;

    @media #{$screen-small} {
        flex-direction: column;
        align-items: flex-start;
    }  
    
    &__title {
        @include text-xl($font-weight-semibold, $line-height-large);

        color: $primary-invert;

        @media #{$screen-big} {
            font-size: rem($font-size-large);
        }

        @media #{$screen-small} {
            font-size: rem($font-size-medium);
        }
    }

    &__submit-button {
        $safe-margin: 20px;

        margin-left: rem($safe-margin);

        @media #{$screen-small} {
            width: 100%;

            margin-left: 0;
            margin-top: rem($gap-medium);
        }  
    }
}
</style>